const _excluded = ["children", "className", "color", "cursor", "fill", "display", "fontLineHeight", "fontSize", "fontWeight", "height", "keyline", "overlay", "padding", "radius", "shadow", "style", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
import { pressableColors, PressableThemeContext } from "./PressableThemeProvider";
import { PressableContext } from "./";
import getPaddingClassNames from "../Box/getPaddingClassNames";
const hexColorToSailColor = hex => {
  switch (hex) {
    case pressableColors.blue500:
      return 'blue';
    case pressableColors.red500:
      return 'red';
    case pressableColors.gray700:
      return 'default';
    case pressableColors.gray300:
      return 'disabled';
    case pressableColors.gray900:
      return 'dark';
    case pressableColors.white:
      return 'white';
    default:
      return 'inherit';
  }
};
const {
  useContext
} = React;
const PressableCore = props => {
  const {
      children,
      className,
      color = 'default',
      cursor = 'default',
      fill = 'none',
      display = 'inline-flex',
      fontLineHeight = 20,
      fontSize = 14,
      fontWeight = 'regular',
      height = 'auto',
      keyline = 'none',
      overlay = false,
      padding,
      radius = 'none',
      shadow = 'none',
      style,
      width = 'auto'
    } = props,
    remaining = _objectWithoutProperties(props, _excluded);
  const context = useContext(PressableThemeContext);
  const getClasses = () => {
    return classNames('PressableCore', {
      // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'PressableCoreCursor' and '"arrow"' have no overlap.
      'PressableCore--cursor--arrow': cursor === 'arrow',
      'PressableCore--cursor--pointer': cursor === 'pointer',
      'PressableCore--cursor--text': cursor === 'text',
      'PressableCore--height--jumbo': height === 'jumbo',
      'PressableCore--height--large': height === 'large',
      'PressableCore--height--medium': height === 'medium',
      'PressableCore--height--small': height === 'small',
      'PressableCore--radius--all': radius === 'all',
      'PressableCore--radius--bottom': radius === 'bottom',
      'PressableCore--radius--bottomLeft': radius === 'bottomLeft',
      'PressableCore--radius--bottomRight': radius === 'bottomRight',
      'PressableCore--radius--circle': radius === 'circle',
      'PressableCore--radius--left': radius === 'left',
      'PressableCore--radius--right': radius === 'right',
      'PressableCore--radius--top': radius === 'top',
      'PressableCore--radius--topLeft': radius === 'topLeft',
      'PressableCore--radius--topRight': radius === 'topRight',
      'PressableCore--width': width,
      'PressableCore--width--auto': width === 'auto',
      'PressableCore--width--long': width === 'long',
      'PressableCore--width--maximized': width === 'maximized',
      'PressableCore--width--short': width === 'short'
    }, className);
  };
  const getPaddingClasses = () => {
    const paddingMap = typeof padding === 'number' ? {
      all: padding
    } : padding;
    return paddingMap ? getPaddingClassNames(paddingMap) : null;
  };
  const getContextClasses = () => {
    return classNames('PressableContext', getPaddingClasses(), {
      // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'PressableCoreCursor' and '"arrow"' have no overlap.
      'PressableContext--cursor--arrow': cursor === 'arrow',
      'PressableContext--cursor--pointer': cursor === 'pointer',
      'PressableContext--cursor--text': cursor === 'text',
      'PressableContext--display--block': display === 'block',
      'PressableContext--display--flex': display === 'flex',
      'PressableContext--display--inline': display === 'inline',
      'PressableContext--display--inlineFlex': display === 'inline-flex',
      'PressableContext--fontLineHeight--16': fontLineHeight === 16,
      'PressableContext--fontLineHeight--20': fontLineHeight === 20,
      'PressableContext--fontLineHeight--24': fontLineHeight === 24,
      'PressableContext--fontLineHeight--28': fontLineHeight === 28,
      'PressableContext--fontSize--13': fontSize === 13,
      'PressableContext--fontSize--14': fontSize === 14,
      'PressableContext--fontSize--16': fontSize === 16,
      'PressableContext--fontWeight--medium': fontWeight === 'medium',
      'PressableContext--fontWeight--regular': fontWeight === 'regular',
      'PressableContext--height': height,
      'PressableContext--height--jumbo': height === 'jumbo',
      'PressableContext--height--large': height === 'large',
      'PressableContext--height--medium': height === 'medium',
      'PressableContext--height--small': height === 'small',
      'PressableContext--radius--all': radius === 'all',
      'PressableContext--radius--bottom': radius === 'bottom',
      'PressableContext--radius--bottomLeft': radius === 'bottomLeft',
      'PressableContext--radius--bottomRight': radius === 'bottomRight',
      'PressableContext--radius--circle': radius === 'circle',
      'PressableContext--radius--left': radius === 'left',
      'PressableContext--radius--right': radius === 'right',
      'PressableContext--radius--top': radius === 'top',
      'PressableContext--radius--topLeft': radius === 'topLeft',
      'PressableContext--radius--topRight': radius === 'topRight',
      'PressableContext--width': width,
      'PressableContext--width--auto': width === 'auto',
      'PressableContext--width--long': width === 'long',
      'PressableContext--width--maximized': width === 'maximized',
      'PressableContext--width--short': width === 'short'
    });
  };
  const getDisplayFlex = () => {
    return display === 'flex' || display === 'inline-flex' ? {
      display
    } : {};
  };
  const getDisplayStyle = () => {
    return display === 'block' || display === 'inline' ? {
      display
    } : {};
  };
  const getColorStyle = () => {
    // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'PressableCoreColor' and '"none"' have no overlap.
    return color === 'none' ? {} : {
      color: context.color[color]
    };
  };
  const getFillStyle = () => {
    return fill === 'none' ? {} : {
      backgroundColor: context.fill[fill]
    };
  };
  const getBlankShadow = () => {
    return `0 0 0 0 rgba(0,0,0,0)`; // Makes transitions of the shadows nice and smooth.
  };

  const getKeylinePosition = () => {
    // @ts-expect-error - TS2339 - Property 'inset' does not exist on type '"none" | PressableCoreKeylineMap'.
    return keyline && keyline.inset === true ? 'inset' : 'outset';
  };
  const getKeylineInset = () => {
    return getKeylinePosition() === 'inset';
  };
  const getKeylineWidth = () => {
    // @ts-expect-error - TS2339 - Property 'width' does not exist on type '"none" | PressableCoreKeylineMap'.
    return keyline && keyline.width === 2 ? '2px' : '1px';
  };
  const getKeyline = () => {
    if (!keyline || keyline === 'none') {
      return `${getBlankShadow()}, ${getBlankShadow()}`;
    }
    const keylineWidth = keyline && keyline.width === 2 ? '2px' : '1px';
    let keylineSide = '';
    let keylineSideBottom = '';
    let keylineSideLeft = '';
    let keylineSideRight = '';
    let keylineSideTop = '';
    if (keyline && keyline.side === 'all') {
      keylineSide = getKeylineInset() ? `inset 0 0 0 ${keylineWidth}` : `0 0 0 ${keylineWidth}`;
    } else if (keyline && keyline.side === 'bottom') {
      keylineSide = getKeylineInset() ? `inset 0 -${keylineWidth} 0 0` : `0 ${keylineWidth} 0 0`;
    } else if (keyline && keyline.side === 'left') {
      keylineSide = getKeylineInset() ? `inset ${keylineWidth} 0 0 0` : `-${keylineWidth} 0 0 0`;
    } else if (keyline && keyline.side === 'right') {
      keylineSide = getKeylineInset() ? `inset -${keylineWidth} 0 0 0` : `${keylineWidth} 0 0 0`;
    } else if (keyline && keyline.side === 'top') {
      keylineSide = getKeylineInset() ? `inset 0 ${keylineWidth} 0 0` : `0 -${keylineWidth} 0 0`;
    } else if (keyline && keyline.side === 'horizontal') {
      keylineSideLeft = getKeylineInset() ? `inset ${keylineWidth} 0 0 0` : `-${keylineWidth} 0 0 0`;
      keylineSideRight = getKeylineInset() ? `inset -${keylineWidth} 0 0 0` : `${keylineWidth} 0 0 0`;
    } else if (keyline && keyline.side === 'vertical') {
      keylineSideBottom = getKeylineInset() ? `inset 0 -${keylineWidth} 0 0` : `0 ${keylineWidth} 0 0`;
      keylineSideTop = getKeylineInset() ? `inset 0 ${keylineWidth} 0 0` : `0 -${keylineWidth} 0 0`;
    }

    // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
    const keylineColor = context.keyline[keyline.color] || context.keyline.base;

    // The follow values **MUST** result is the same amount of shadows in
    // order to make sure the transitions between keylines is smooth.
    if (keyline && keyline.side === 'horizontal') {
      return `${keylineSideLeft} ${keylineColor}, ${keylineSideRight} ${keylineColor}`;
    } else if (keyline && keyline.side === 'vertical') {
      return `${keylineSideBottom} ${keylineColor}, ${keylineSideTop} ${keylineColor}`;
    }
    return `${keylineSide} ${keylineColor}, ${getBlankShadow()}`;
  };
  const getHeight = () => {
    return typeof height === 'number' ? {
      height: `${height}px`
    } : {};
  };
  const getOverlayClasses = () => {
    return classNames('PressableCore-overlay', {
      'PressableCore-overlay--extendBy1': !getKeylineInset() && getKeylineWidth() === '1px',
      'PressableCore-overlay--extendBy2': !getKeylineInset() && getKeylineWidth() === '2px',
      'PressableCore-overlay--isVisible': overlay
    });
  };
  const getPadding = () => {
    return typeof padding === 'number' ? {
      all: padding
    } : padding;
  };
  const getRadius = () => {
    return typeof radius === 'number' ? {
      borderRadius: `${radius}px`
    } : {};
  };
  const getShadow = () => {
    // The follow values **MUST** provide a blank shadow to make sure the
    // transitions to other combinations of shadows is smooth.
    //
    // Current expectation is 1 shadow each.
    const hoverShadow =
    // @ts-expect-error - TS2339 - Property 'hovered' does not exist on type '"none" | PressableCoreShadowMap'.
    shadow && shadow.hovered ? `0 3px 9px 0 ${context.shadow.ambient}` : getBlankShadow();
    const elevatedShadow =
    // @ts-expect-error - TS2339 - Property 'elevated' does not exist on type '"none" | PressableCoreShadowMap'.
    shadow && shadow.elevated ? `0 2px 5px 0 ${context.shadow.ambient}` : getBlankShadow();
    const baseShadow =
    // @ts-expect-error - TS2339 - Property 'elevated' does not exist on type '"none" | PressableCoreShadowMap'.
    shadow && shadow.elevated ? `0 1px 1px 0 ${context.shadow.key}` : getBlankShadow();
    const focusShadow =
    // @ts-expect-error - TS2339 - Property 'focused' does not exist on type '"none" | PressableCoreShadowMap'.
    shadow && shadow.focused ? `0 0 0 4px ${context.shadow.focus}` : getBlankShadow();
    const focusShadowKeyline =
    // @ts-expect-error - TS2339 - Property 'focused' does not exist on type '"none" | PressableCoreShadowMap'.
    shadow && shadow.focused && keyline === 'none' ? `0 0 0 1px ${context.keyline.focus}` : getBlankShadow();

    // First shadow wins
    const shadows = [focusShadowKeyline, focusShadow, baseShadow, getKeyline(), hoverShadow, elevatedShadow];
    const boxShadow = shadows.filter(shadow => !!shadow).join(',');
    return boxShadow ? {
      boxShadow
    } : {};
  };
  const getWidth = () => {
    return typeof width === 'number' ? {
      minWidth: `${width}px`,
      width: `${width}px`
    } : {};
  };
  const getStyle = () => {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getDisplayStyle()), getFillStyle()), getHeight()), getShadow()), getRadius()), getWidth()), style);
  };
  const getContextStyle = () => {
    return _objectSpread({}, getColorStyle());
  };
  return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    className: getClasses(),
    flex: getDisplayFlex(),
    style: _objectSpread({}, getStyle())
  }), /*#__PURE__*/React.createElement(Box, {
    className: "PressableCore-base"
  }, /*#__PURE__*/React.createElement(PressableContext.Provider, {
    value: {
      pressableContextClasses: getContextClasses(),
      color: hexColorToSailColor(context.color[color]),
      cursor,
      display,
      fontLineHeight,
      fontSize,
      fontWeight,
      height,
      padding: getPadding(),
      width,
      style: getContextStyle()
    }
  }, children)), /*#__PURE__*/React.createElement(Box, {
    className: getOverlayClasses(),
    background: "white",
    style: _objectSpread({}, getRadius())
  }));
};
export default PressableCore;